import Phaser from 'phaser';
import gameData from '../gameData';
import ABCyaPhaser from '@abcya/abcya_phaser';
import GameBackground from '../game/GameBackground';
import SelectScreen from './SelectScreen';

export default class ReviewScreen extends Phaser.Scene {
  static get KEY() { return 'ReviewScreen'; }

  create() {
    GameBackground.instance.switchBg('level', false);

    this.reviewSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.levels = [];
    for (let i = 0; i < gameData.allLevels.length; i++) {
      const levelData = gameData.allLevels[i];

      const clipContainer = this.add.container();
      let baseClip = null;
      if (levelData.baseType !== '') {
        baseClip = ABCyaPhaser.Images.addImage(0, 0, levelData.baseType, clipContainer).setOrigin(0);
      }

      const name = levelData.destinationId.toLowerCase();
      let atlas = ABCyaPhaser.Images.DEFAULT_ATLAS;
      switch (name) {
        case 'bank':
        case 'fire department':
        case 'library':
        case 'police station':
        case 'post office':
        case 'school':
        case 'shopping mall':
        case 'supermarket':
          atlas = ABCyaPhaser.Images.LOCALIZATION_ATLAS;
      }
      const levelClip = ABCyaPhaser.Images.addImage(0, 0, name, clipContainer, atlas).setOrigin(0)
        .setInteractive()
        .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
          this.playItemSound(clipContainer);
        });

      if (baseClip !== null) {
        levelClip.x = (baseClip.getBounds().width / 2) - (levelClip.getBounds().width / 2);
        levelClip.y = (baseClip.getBounds().height / 2) - (levelClip.getBounds().height / 2);
      }

      const levelObj = { clip: clipContainer, levelName: levelData.destinationId.toLowerCase() };
      this.levels.push(levelObj);
    }

    this.positionLevelDisplays();

    this.menuBtn = ABCyaPhaser.Images.addImage(0, 0, 'btn-menu', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setOrigin(0)
      .setInteractive()
      .once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
        this.cleanUp();
      });

    this.menuBtn.x = this.scale.width - this.menuBtn.getBounds().width - 80;
    this.menuBtn.y = 20;

    ABCyaPhaser.Audio.playSound('review-inst', this.reviewSound);
  }

  positionLevelDisplays() {
    for (let i = 0; i < this.levels.length; i++) {
      const clip = this.levels[i].clip;
      clip.y = (clip.getBounds().height / 2) * i;
      clip.x = i % 2 === 0 ? 40 : this.scale.width - clip.getBounds().width - 40;
      if (i === this.levels.length - 1) clip.y += 50;
    }
  };

  playItemSound(e) {
    if (this.reviewSound) this.reviewSound.pause();

    const soundInfo = this.getLevelInfoFromClip(e);
    const soundName = soundInfo.levelName === 'physical activity' ? `${soundInfo.levelName}-sound` : `${soundInfo.levelName}-long`;

    ABCyaPhaser.Audio.playSound(soundName, this.reviewSound);
  };

  getLevelInfoFromClip(clip) {
    let data = null;
    for (let i = 0; i < this.levels.length; i++) {
      if (this.levels[i].clip === clip) {
        data = this.levels[i];
        break;
      }
    }

    return data;
  };

  cleanUp() {
    if (this.reviewSound !== null) {
      this.reviewSound.stop();
      this.reviewSound.destroy();
      this.reviewSound = null;
    }

    this.scene.start(SelectScreen.KEY);
  };
}